import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CONFIGURE_DEFAULT_PARAMS, LoadGridPayload } from '@data-access/shared';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { userTokenizer } from '../store/token';

export const userResolver = (route: ActivatedRouteSnapshot) => {
  const _userSignalStore = userTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);
  const params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );

  const _payload: LoadGridPayload = {
    params,
  };

  // set internal to false to load the client users by default when user navigates to user management page
  _userSignalStore.setURL(false);

  // load users based on the default params when user lands on user management page
  _userSignalStore.loadUserGrid(_payload);

  return !!_userSignalStore.$users();
};
